import { useApp } from './useApp'

export const useCanCreate = () => {
  const { me } = useApp()
  return (
    me?.isSuperuser ||
    me?.userPermissions?.includes('can_read_write') ||
    me?.userPermissions?.includes('can_read_write_update')
  )
}

export const useCanRead = () => {
  const { me } = useApp()
  return (
    me?.isSuperuser ||
    me?.userPermissions?.includes('can_read') ||
    me?.userPermissions?.includes('can_read_write') ||
    me?.userPermissions?.includes('can_read_write_update')
  )
}

export const useCanUpdate = () => {
  const { me } = useApp()
  return (
    me?.isSuperuser || me?.userPermissions?.includes('can_read_write_update')
  )
}

export const useCanDelete = () => {
  const { me } = useApp()
  return me?.isSuperuser || me?.userPermissions?.includes('can_delete')
}

export const useCanDownloadReport = () => {
  const { me } = useApp()
  return (
    me?.isSuperuser || me?.userPermissions?.includes('can_download_reports')
  )
}

export const useCanWrite = () => {
  const { me } = useApp()
  return (
    me?.isSuperuser ||
    me?.userPermissions?.includes('can_read_write') ||
    me?.userPermissions?.includes('can_read_write_update')
  )
}

export const useCanUploadFiles = () => {
  const { me } = useApp()
  return me?.isSuperuser || me?.userPermissions?.includes('can_upload_files')
}
